import { registerPlugin } from '@capacitor/core';
const NativeInput = registerPlugin('NativeInput', {
    web: () => import('./web').then((m) => new m.NativeInputWeb()),
});
export * from './definitions';
export { NativeInput };
//# sourceMappingURL=index.js.map